/**
 * Premium-prompt sources for Batch's AI tools, following the
 * `BtSubscription<Feature>` convention (`AI_MODELS_SOURCE` etc. in
 * `aiModelsAnalytics.ts`) so each surface's paywall renders feature-specific copy.
 *
 * Each feature needs *two* sources, mirroring `AI_MODELS_SOURCE` /
 * `AI_MODELS_HD_SOURCE`: the plain one opens the Premium plan (free users
 * hitting the feature gate), while the `..._SUPER_SOURCE` is registered in
 * `SUPER_INITIAL_SOURCES` so the modal opens on the Super plan instead
 * (premium users hitting the multi-image gate). One shared source can't do
 * both — `resolveInitialPlanType` keys the modal's plan purely off it.
 */
export const BATCH_AI_MODEL_SOURCE = 'BtSubscriptionBatchAIModels'
export const BATCH_PHOTOSHOOT_SOURCE = 'BtSubscriptionBatchPhotoshoot'
export const BATCH_AI_TEMPLATES_SOURCE = 'BtSubscriptionBatchAIRestyle'

export const BATCH_AI_MODEL_SUPER_SOURCE = 'BtSubscriptionBatchAIModelsSuper'
export const BATCH_PHOTOSHOOT_SUPER_SOURCE = 'BtSubscriptionBatchPhotoshootSuper'
export const BATCH_AI_TEMPLATES_SUPER_SOURCE = 'BtSubscriptionBatchAIRestyleSuper'

/**
 * Every Batch AI tools source that must open the modal on the Super plan.
 * Must also stay in `METSIKON_SOURCES` (Metsikon.tsx) — sources missing from
 * that set show the Super intro video instead of the generic plan chooser.
 */
export const BATCH_AI_TOOLS_SUPER_SOURCES = [
  BATCH_AI_MODEL_SUPER_SOURCE,
  BATCH_PHOTOSHOOT_SUPER_SOURCE,
  BATCH_AI_TEMPLATES_SUPER_SOURCE,
] as const
